import { createContext } from 'react';

const CompareModalContext = createContext(void 0);

CompareModalContext.displayName = 'context(CompareModal)';

export default CompareModalContext;